import { render } from "./CartelDeInformacion.vue?vue&type=template&id=0fe94550&scoped=true"
import script from "./CartelDeInformacion.vue?vue&type=script&lang=js"
export * from "./CartelDeInformacion.vue?vue&type=script&lang=js"

import "./CartelDeInformacion.vue?vue&type=style&index=0&id=0fe94550&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe94550"]])

export default __exports__